import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Button, Space, Table, FormInstance, Modal, Tooltip, notification } from "antd";
import { withPickingListLogic } from "../../components/hoc_picking_list"
import "./picking_list.css";
import BrowserPickingListSo from "./browser_picking_list_so";
import AddItemAvailable, { DataType } from "./add_item_available_picking_list";
import AddEditPickingItem from "./add_edit_picking_item";
import TextArea from "antd/es/input/TextArea";

interface SalesMasterRecord {
    key: React.Key;
    id: number;
    so_no: string;
    sales_date: string;
    cs_name: string;
    purchase_order_no?: string;
    order_type?: string;
    warehouse_group?: string;
}

interface SalesOrderItem {
    key: React.Key;
    item_code: string;
    item_name: string;
    uom: string;
    location_code_rack: string;
    available_quantity: number;
    demand_quantity: number;
    supply_quantity: number;
}

interface PickingListProps {
    rowSelection: any;
    columns: any;
    form: FormInstance;
    isSoModalVisible: boolean;
    showSoModal: () => void;
    handleSoModalOk: () => void;
    handleSoModalCancel: () => void;
    handleSoRecordSelected: (record: SalesMasterRecord) => void;
    pickingListItems: any[];
    isAddItemModalVisible: boolean;
    showAddItemModal: () => void;
    handleAddItemModalOk: () => void;
    handleAddItemModalCancel: () => void;
    selectedSalesOrderNo: string | undefined;
    selectedWarehouseGroupCode: string | undefined;
    debouncedAutoSave: (changedValues: any, allValues: any) => void;
    handleDeleteSelectedItems: () => void;
    onSelectAvailableItems: (items: DataType[]) => void;
    handleVoid: () => void;
    handleSubmit: () => void;
    isReadyStatus: boolean;
    isAddEditPickingItemFormModalVisible: boolean;
    showAddEditPickingItemFormModal: () => void;
    handleAddEditPickingItemFormModalOk: (updatedItem?: SalesOrderItem) => void;
    handleAddEditPickingItemFormModalCancel: () => void;
    editingPickingItem: SalesOrderItem | null;
    handleRowDoubleClick: (record: SalesOrderItem) => void;
    handlePrint: () => void;
    isPrinting: boolean;
    isSubmitting: boolean;
    isVoiding: boolean;
    isStatusDraft: boolean;
    autosaveStatus: 'idle' | 'processing' | 'error' | 'stopped';
    pickingStatusMap: Map<string, { picked: number; demand: number }>;
    handleNew: () => void;
}

const PickingList: React.FC<PickingListProps> = ({
    rowSelection,
    columns,
    form,
    isSoModalVisible,
    showSoModal,
    handleSoModalOk,
    handleSoModalCancel,
    handleSoRecordSelected,
    pickingListItems,
    isAddItemModalVisible,
    showAddItemModal,
    handleAddItemModalOk,
    handleAddItemModalCancel,
    selectedSalesOrderNo,
    selectedWarehouseGroupCode,
    debouncedAutoSave,
    handleDeleteSelectedItems,
    onSelectAvailableItems,
    handleVoid,
    handleSubmit,
    isReadyStatus,
    isAddEditPickingItemFormModalVisible,
    showAddEditPickingItemFormModal,
    handleAddEditPickingItemFormModalOk,
    handleAddEditPickingItemFormModalCancel,
    editingPickingItem,
    handleRowDoubleClick,
    handlePrint,
    isPrinting,
    isSubmitting,
    isVoiding,
    isStatusDraft,
    autosaveStatus,
    pickingStatusMap,
    handleNew,
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="i2clq">
                <div className="gjs-grid-column" id="iuek8">
                    <Breadcrumb
                        items={[
                            {

                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_picking_list",
                                title: (
                                    <>
                                        <span>Data Picking List</span>
                                    </>
                                ),
                            },
                            {
                                title: "Picking List",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="uuuuriasj">
                <div className="gjs-grid-column" id="iiioedjsk">
                    <Button className="pr-button" onClick={handleNew}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
                                clipRule="evenodd"
                            />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg>
                        New
                    </Button>
                    <Button
                        className="pr-button"
                        onClick={() => {
                            if (pickingListItems.length === 0) {
                                notification.warning({
                                    message: "Peringatan",
                                    description: "Data kosong harap periksa !",
                                });
                            } else {
                                handleSubmit();
                            }
                        }}
                        disabled={!isStatusDraft || autosaveStatus === 'processing'}
                        loading={isSubmitting}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                    <Button
                        className="pr-button"
                        onClick={handleVoid}
                        disabled={!(form.getFieldValue('status') === 'Draft' || form.getFieldValue('status') === '1') || autosaveStatus === 'processing'}
                        loading={isVoiding}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Void
                    </Button>
                    <Button className="pr-button" onClick={handlePrint} disabled={isStatusDraft || autosaveStatus === 'processing'} loading={isPrinting}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="ikgwd">
                <div className="gjs-grid-column" id="ixvzf">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 530, paddingRight: '30px' }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '320px' } }}
                        className="custom-info-purchase-request"
                        onValuesChange={debouncedAutoSave}
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Picking List No"
                            name="no_picking"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Picking List Date"
                            name="date_picking"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Sales Order No"
                            name="sales_order"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    placeholder=""
                                    style={{
                                        width: "90%",
                                    }}
                                    value={form.getFieldValue('sales_order') || ''} readOnly
                                />
                                <Button
                                    type="primary"
                                    id="browser_picking_list_so"
                                    onClick={showSoModal}
                                    disabled={isReadyStatus || !!selectedSalesOrderNo}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{
                                                width: "40px",
                                                height: "20px",
                                            }}
                                        >
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Sales Order Date"
                            name="sales_order_date"
                            style={{
                                marginBottom: "5px", width: "60%",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Transaction Type"
                            name="transaction_type"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Customer Name"
                            name="customer_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Customer Code"
                            name="customer_code"
                            style={{
                                marginBottom: "5px",
                                display: 'none',
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                    </Form>
                </div>
                {/* Grid Row 3 */}
                <div className="gjs-grid-row" id="ixvzf">
                    <div className="gjs-grid-column" id="ixwyz">
                        <Form
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 500, paddingRight: '30px' }}
                            labelCol={{ style: { width: '190px', textAlign: "left" } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-purchase-request"
                            onValuesChange={debouncedAutoSave}
                        >
                            <Form.Item
                                label="Created By"
                                name="created_user"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Purchase Order No."
                                name="purchase_order"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Order Type"
                                name="order_type"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse Group"
                                name="warehouse_group"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>


            <div className="gjs-grid-row" id="iy70x">
                <div className="gjs-grid-column" id="ipt3k">
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        style={{ paddingRight: '30px' }}
                        dataSource={pickingListItems}
                        scroll={{ x: 900 }}
                        className="table-gr"
                        onRow={(record) => ({
                            onDoubleClick: () => {
                                if (isStatusDraft) {
                                    handleRowDoubleClick(record);
                                }
                            },
                        })}
                    />
                    <div style={{ marginTop: "20px", textAlign: "left" }}>
                        <Space>
                            <Button
                                type="primary"
                                style={{
                                    height: "40px",
                                    width: "100px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                                onClick={showAddItemModal}
                                disabled={isReadyStatus}
                            >
                                List Item
                            </Button>
                            <Button
                                type="primary"
                                id="delete_line"
                                style={{
                                    height: "40px",
                                    width: "90px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                    </svg>
                                }
                                onClick={handleDeleteSelectedItems}
                                disabled={isReadyStatus}
                            >
                                Delete
                            </Button>
                        </Space>
                    </div>
                </div>
            </div>
            <Modal
                title="Browser Sales Order"
                open={isSoModalVisible}
                onCancel={handleSoModalCancel}
                width="890px"
                footer={null}
            >
                <BrowserPickingListSo onRowDoubleClick={handleSoRecordSelected} />
            </Modal>
            <Modal
                title="List Item"
                open={isAddItemModalVisible}
                onOk={handleAddItemModalOk}
                onCancel={handleAddItemModalCancel}
                width="fit-content"
                footer={null}
                destroyOnClose
            >
                <AddItemAvailable
                    soNo={selectedSalesOrderNo}
                    warehouseGroup={selectedWarehouseGroupCode}
                    onSelectItems={onSelectAvailableItems}
                    onCloseModal={handleAddItemModalOk}
                    pickingListItems={pickingListItems}
                    pickingStatusMap={pickingStatusMap}
                />
            </Modal>
            <Modal
                title="Add/Edit Picking Item"
                open={isAddEditPickingItemFormModalVisible}
                onCancel={handleAddEditPickingItemFormModalCancel}
                width="450px"
                footer={null}
            >
                <AddEditPickingItem
                    editData={editingPickingItem}
                    warehouseGroup={selectedWarehouseGroupCode}
                    onSave={handleAddEditPickingItemFormModalOk}
                    onCancel={handleAddEditPickingItemFormModalCancel}
                />
            </Modal>
        </div>
    );
};

export default withPickingListLogic(PickingList);